module.exports = __webpack_public_path__ + "static/media/product_detail_02.a6cada48.jpg";